import React from "react";
import MainLayout from "../../layouts/MainLayout";

function Profile() {
  const user = JSON.parse(sessionStorage.getItem("user"));

  return (
    <MainLayout>
      <div className="card shadow border-0 rounded-3">
        
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#50C4CC" }}
        >
          <h4 className="mb-0">My Profile</h4>
        </div>

        <div className="card-body">
          <div className="row">

            <div className="col-md-6 mb-3">
              <label className="fw-bold">User ID</label>
              <p className="mb-0">{user?.unique_id}</p>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold">Name</label>
              <p className="mb-0">{user?.name}</p>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold">Mobile Number</label>
              <p className="mb-0">{user?.mobile_number}</p>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold">Email</label>
              <p className="mb-0">{user?.email}</p>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold">Designation</label>
              <p className="mb-0">{user?.designation}</p>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold">Role</label>
              <p className="mb-0">{user?.role}</p>
            </div>

            <div className="col-md-6 mb-3">
              <label className="fw-bold">Status</label>
              <p className="mb-0">{user?.status}</p>
            </div>

          </div>
        </div>

      </div>
    </MainLayout>
  );
}

export default Profile;